
import {Options, Vue} from "vue-class-component";
import {isMobile} from "@/shared/utils/js.utils";
import * as $ from "jquery";
@Options({
  emits: ['update:show', 'onClose'],
  data: function() {
    return {
      showModalCentered: true
    }
  },
  props: {
    backdropClass: '',
    show: {
      type: Boolean,
      default: false,
    },
    hasScrollBar: {
      type: Boolean,
      default: true,
    },
    hasDarkForeground: {
      type: Boolean,
      default: true
    },
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    closeOnClickOut: {
      type: Boolean,
      default: true
    },
    hasHeader: {
      type: Boolean,
      default: true,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ""
    },
    goldenTitle: false,
    description: "",
    image: {
      type: String,
      default: null
    },
    modalClasses: {
      type: String,
      default: ''
    },
    modalStyles: {},
    maxHeight: {
      type: String,
      default: "480px"
    }
  },
  methods: {
    close() {
      this.$emit('onClose', true)
      this.$emit('update:show', false)
    },
    checkClick(e: any) {
      if(this.closeOnClickOut && $(e.target).parents("#modal-content").length == 0) {
        this.close();
      }
    },
  },
  mounted() {
    /*document.querySelectorAll('input').forEach(item => {
      item.addEventListener('focus', () => {
        this.showModalCentered = !isMobile();
      });
      item.addEventListener('focusout', () => {
        setTimeout(() => {
          this.showModalCentered = true;
        }, 100)
      })
    })*/
  }
})
export default class Modal extends Vue {

}
